import { Component, output, ViewEncapsulation } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { CakeItemVariant } from '../cake-item-variant';

/** Card of a request form: "Order now" on hover, always shown on touch; any click opens the form. */
@Component({
  standalone: true,
  selector: 'cake-item-request',
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, NgTemplateOutlet, RouterLink, TranslateModule],
  templateUrl: './cake-item-request.component.html',
})
export class CakeItemRequestComponent extends CakeItemVariant {
  open = output<void>();
}
